import { FileBase64Model } from "../models/api/file-base64-model";

export const regexBase64Header = new RegExp(/^.+?(;base64),/);

export const toBase64 = (file: File): Promise<FileBase64Model> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () =>
            typeof reader.result === 'string'
                ? resolve({ fileNameWithExtension: file.name, contentType: file.type, contentBase64: reader.result })
                : reject('could not convert to base 64');

        reader.onerror = (error) => reject(error);
    });
